import { Component, OnInit, inject } from '@angular/core';
import { WeatherDashboardCardComponent } from '../../../weather/components/weather-dashboard-card/weather-dashboard-card.component';
import { DevicesDashboardCardComponent } from '../../../devices/components/devices-dashboard-card/devices-dashboard-card.component';
import { FormsModule } from '@angular/forms';
import { CisternItemCardComponent } from '../../../cisterns/components/cistern-item-card/cistern-item-card.component';
import { Store } from '@ngrx/store';
import {
  selectDevicesByType,
  selectFavoriteDevices,
} from '../../../devices/state/device.selectors';
import { AsyncPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { selectAllCisterns } from '../../../cisterns/state/cistern.selectors';
import { NotificationsDashboardCardComponent } from '../../../notifications/components/notifications-dashboard-card/notifications-dashboard-card.component';
import { CisternActions } from '../../../cisterns/state/cistern.actions';
import { DeviceActions } from '../../../devices/state/device.actions';
import { SystemStopComponent } from '../../components/system-stop/system-stop.component';
import { KillSwitchActions } from '../../state/kill-switch.actions';
import {
  selectIsEmergencyStopActive,
  selectIsSystemRunning,
} from '../../state/kill-switch.selectors';
import { DeviceType } from '@birco/rainmesh-api';
import { map } from 'rxjs';
import { DeviceReducedDashboardCardComponent } from '../../../devices/components/device-reduced-dashboard-card/device-reduced-dashboard-card.component';
import { RouteConstants } from '../../../../shared/constants/route-constants';
import { TranslatePipe } from '@ngx-translate/core';
import { IconComponent } from '../../../../shared/icons/icon.component';
import { DeviceGroupActions } from '../../../devices/state/device-groups/device-group.actions';
import { selectFavoriteDeviceGroups } from '../../../devices/state/device-groups/device-group.selectors';
import { DeviceValuesDashboardCardComponent } from '../../components/device-values-dashboard-card/device-values-dashboard-card.component';

@Component({
  selector: 'app-page-dashboard',
  imports: [
    WeatherDashboardCardComponent,
    DevicesDashboardCardComponent,
    FormsModule,
    CisternItemCardComponent,
    AsyncPipe,
    NotificationsDashboardCardComponent,
    SystemStopComponent,
    RouterLink,
    TranslatePipe,
    IconComponent,
    DeviceValuesDashboardCardComponent,
  ],
  templateUrl: './page-dashboard.component.html',
  styleUrl: './page-dashboard.component.scss',
})
export class PageDashboardComponent implements OnInit {
  private store = inject(Store);

  favoriteDevices$ = this.store.select(selectFavoriteDevices);
  favoriteDeviceGroups$ = this.store.select(selectFavoriteDeviceGroups);
  cisternList$ = this.store.select(selectAllCisterns);
  soilDeviceList$ = this.store
    .select(selectDevicesByType(DeviceType.SOIL))
    .pipe(map((l) => l.filter((d) => !d.isOutOfService)));
  flowDeviceList$ = this.store
    .select(selectDevicesByType(DeviceType.FLOW))
    .pipe(map((l) => l.filter((d) => !d.isOutOfService)));
  isSystemRunning$ = this.store.select(selectIsSystemRunning);
  isEmegancyStopActive$ = this.store.select(selectIsEmergencyStopActive);

  isSmartModeRunning = true;

  ngOnInit() {
    this.store.dispatch(
      DeviceActions.public.loadAllDevicesByFilters({
        filter: {},
      }),
    );
    this.store.dispatch(
      DeviceGroupActions.public.loadAllDeviceGroupsByFilters({
        filter: {},
      }),
    );
    this.store.dispatch(CisternActions.public.loadAllCisternsByFilters({}));
  }

  onTriggerKillSwitch(value: boolean) {
    this.store.dispatch(
      KillSwitchActions.public.triggerKillSwitch({ value: value }),
    );
  }

  onTriggerDeviceAction(evtData: { id: string; value: boolean }) {
    this.store.dispatch(
      DeviceActions.public.triggerDeviceAction({
        id: evtData.id,
        value: evtData.value,
      }),
    );
  }

  onTriggerDeviceGroupAction(evtData: { id: string; value: boolean }) {
    this.store.dispatch(
      DeviceGroupActions.public.triggerDeviceGroupAction({
        id: evtData.id,
        value: evtData.value,
      }),
    );
  }

  protected readonly RouteConstants = RouteConstants;
}
